// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input-module__font-s-10___b_NC6 {
  font-size: 10px !important;
}

.Input-module__font-s-12___DSbbW {
  font-size: 12px !important;
}

.Input-module__font-s-13___hSlV_ {
  font-size: 13px !important;
}

.Input-module__font-s-14___X7AKK {
  font-size: 14px !important;
}

.Input-module__font-s-15___vvPgb {
  font-size: 15px !important;
}

.Input-module__font-s-16___KMzXs {
  font-size: 16px !important;
}

.Input-module__font-s-18___IRkTp {
  font-size: 18px !important;
}

.Input-module__font-s-20___mNSGc {
  font-size: 20px !important;
}

.Input-module__font-s-22___Pyub4 {
  font-size: 22px !important;
}

.Input-module__font-s-28___x294D {
  font-size: 28px !important;
}

.Input-module__font-w-400___MYviU {
  font-weight: 400 !important;
}

.Input-module__font-w-500___mJ6OI {
  font-weight: 500 !important;
}

.Input-module__font-w-600___FRQ9C {
  font-weight: 600 !important;
}

.Input-module__font-w-700____cycW {
  font-weight: 700 !important;
}

.Input-module__p-5___B9gxb {
  padding: 5px !important;
}

.Input-module__p-12___dnzEN {
  padding: 12px !important;
}

.Input-module__p-16___PUREQ {
  padding: 16px !important;
}

.Input-module__p-30___FleIU {
  padding: 30px !important;
}

.Input-module__p-b-0___ALb_p {
  padding-bottom: 0 !important;
}

.Input-module__p-b-5___Cfw5j {
  padding-bottom: 5px !important;
}

.Input-module__p-b-10___GqgnO {
  padding-bottom: 10px !important;
}

.Input-module__p-b-12___rvgXF {
  padding-bottom: 12px !important;
}

.Input-module__p-b-16___UZdYT {
  padding-bottom: 16px !important;
}

.Input-module__p-b-18___SEXaA {
  padding-bottom: 18px !important;
}

.Input-module__p-b-20___AwO0h {
  padding-bottom: 20px !important;
}

.Input-module__p-b-25___eCC4z {
  padding-bottom: 25px !important;
}

.Input-module__p-b-30___PwszH {
  padding-bottom: 30px !important;
}

.Input-module__p-b-50___yY8HM {
  padding-bottom: 50px !important;
}

.Input-module__p-t-0___oHq55 {
  padding-top: 0 !important;
}

.Input-module__p-t-12___F_pTg {
  padding-top: 12px !important;
}

.Input-module__p-t-16___LFBQC {
  padding-top: 16px !important;
}

.Input-module__p-t-18___f8Wmj {
  padding-top: 18px !important;
}

.Input-module__p-t-20___Zj1Sc {
  padding-top: 20px !important;
}

.Input-module__p-t-30___Cohzr {
  padding-top: 30px !important;
}

.Input-module__p-t-40___wvKXa {
  padding-top: 40px !important;
}

.Input-module__p-t-50___hW_fP {
  padding-top: 50px !important;
}

.Input-module__p-l-20___s5xqr {
  padding-left: 20px !important;
}

.Input-module__p-l-30____FWsC {
  padding-left: 30px !important;
}

.Input-module__p-l-40___fjVuK {
  padding-left: 40px !important;
}

.Input-module__p-r-16___cJsy4 {
  padding-right: 16px !important;
}

.Input-module__p-r-20___wtVWr {
  padding-right: 20px !important;
}

.Input-module__p-r-30___sQ1Tt {
  padding-right: 30px !important;
}

.Input-module__p-r-50___YRp5u {
  padding-right: 50px !important;
}

.Input-module__p-r-60___a4Zgw {
  padding-right: 60px !important;
}

.Input-module__m-b-1___fY0im {
  margin-bottom: 1px !important;
}

.Input-module__m-b-2___fdkQ5 {
  margin-bottom: 2px !important;
}

.Input-module__m-b-6___Rrbdb {
  margin-bottom: 6px !important;
}

.Input-module__m-b-8___MJuGL {
  margin-bottom: 8px !important;
}

.Input-module__m-b-10___P3SMb {
  margin-bottom: 10px !important;
}

.Input-module__m-b-14___g9bqX {
  margin-bottom: 14px !important;
}

.Input-module__m-b-16___eUu1l {
  margin-bottom: 16px !important;
}

.Input-module__m-b-20___xfCrz {
  margin-bottom: 20px !important;
}

.Input-module__m-b-22___Zrjeb {
  margin-bottom: 22px !important;
}

.Input-module__m-b-24___NxEFx {
  margin-bottom: 24px !important;
}

.Input-module__m-b-30___dxJZr {
  margin-bottom: 30px !important;
}

.Input-module__m-b-32___MiVno {
  margin-bottom: 32px !important;
}

.Input-module__m-b-40___m6asB {
  margin-bottom: 40px !important;
}

.Input-module__m-t-2___MaRrL {
  margin-top: 2px !important;
}

.Input-module__m-t-3___mVTFn {
  margin-top: 3px !important;
}

.Input-module__m-t-4___dxSjt {
  margin-top: 4px !important;
}

.Input-module__m-t-5___CHyZG {
  margin-top: 5px !important;
}

.Input-module__m-t-8___rSoyu {
  margin-top: 8px !important;
}

.Input-module__m-t-10___sb9lr {
  margin-top: 10px !important;
}

.Input-module__m-t-15___SIbRr {
  margin-top: 15px !important;
}

.Input-module__m-t-16___wux7P {
  margin-top: 16px !important;
}

.Input-module__m-t-20___QZqs5 {
  margin-top: 20px !important;
}

.Input-module__m-t-22___nQE4j {
  margin-top: 22px !important;
}

.Input-module__m-t-30___owRzp {
  margin-top: 30px !important;
}

.Input-module__m-t-32____vHym {
  margin-top: 32px !important;
}

.Input-module__m-l-auto___KCGxW {
  margin-left: auto !important;
}

.Input-module__m-l-4___WUuti {
  margin-left: 4px !important;
}

.Input-module__m-l-5___b2oNG {
  margin-left: 5px !important;
}

.Input-module__m-l-6___u9CRM {
  margin-left: 6px !important;
}

.Input-module__m-l-8___WUQr2 {
  margin-left: 8px !important;
}

.Input-module__m-l-10___h8dfZ {
  margin-left: 10px !important;
}

.Input-module__m-l-16___qUWKC {
  margin-left: 16px !important;
}

.Input-module__m-l-20___Uo7B2 {
  margin-left: 20px !important;
}

.Input-module__m-l-24___YaFIM {
  margin-left: 24px !important;
}

.Input-module__m-l-30___uF5OW {
  margin-left: 30px !important;
}

.Input-module__m-l-35___al3mX {
  margin-left: 35px !important;
}

.Input-module__m-l-40___rw_Vj {
  margin-left: 40px !important;
}

.Input-module__m-r-8___O1Nfk {
  margin-right: 8px !important;
}

.Input-module__m-r-10___nBc14 {
  margin-right: 10px !important;
}

.Input-module__m-r-16___zZFax {
  margin-right: 16px !important;
}

.Input-module__m-r-20___to2kX {
  margin-right: 20px !important;
}

.Input-module__m-r-24___jxLaL {
  margin-right: 24px !important;
}

.Input-module__m-r-30___qywy6 {
  margin-right: 30px !important;
}

.Input-module__m-r-40___mwUyh {
  margin-right: 40px !important;
}

.Input-module__border-r-3___nF9dM {
  border-radius: 3px !important;
}

.Input-module__border-r-4____5nPG {
  border-radius: 4px !important;
}

.Input-module__border-r-6___obl0P {
  border-radius: 6px !important;
}

.Input-module__border-r-10___iWydD {
  border-radius: 10px !important;
}

.Input-module__border-r-12___Vv7qq {
  border-radius: 12px !important;
}

.Input-module__border-r-16___ZMYOF {
  border-radius: 16px !important;
}

.Input-module__border-r-50___Zh9N8 {
  border-radius: 50% !important;
}

.Input-module__primary-border___uuJSo {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Input-module__primary-border-b___bCU8s {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Input-module__primary-border-t___EpYOn {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Input-module__primary-border-l___ekDX6 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Input-module__primary-border-r___fEdNp {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Input-module__secondary-border___q72kD {
  border: 1px solid #637768;
}

.Input-module__secondary-border-b___RIrjp {
  border-bottom: 1px solid #637768;
}

.Input-module__secondary-border-t___fYbTA {
  border-top: 1px solid #637768;
}

.Input-module__secondary-border-l___g3P7s {
  border-left: 1px solid #637768;
}

.Input-module__secondary-border-r___LJUcR {
  border-right: 1px solid #637768;
}

.Input-module__gap-0___WcfK1 {
  gap: 0 !important;
}

.Input-module__gap-2___kAEKl {
  gap: 2px !important;
}

.Input-module__gap-4___EF5U5 {
  gap: 4px !important;
}

.Input-module__gap-5___ljDha {
  gap: 5px !important;
}

.Input-module__gap-6___NyRsM {
  gap: 6px !important;
}

.Input-module__gap-8___VaOBt {
  gap: 8px !important;
}

.Input-module__gap-10___t9mZE {
  gap: 10px !important;
}

.Input-module__gap-12___rTE5S {
  gap: 12px !important;
}

.Input-module__gap-14___afKUs {
  gap: 14px !important;
}

.Input-module__gap-16___QzhAt {
  gap: 16px !important;
}

.Input-module__gap-18___mtad9 {
  gap: 18px !important;
}

.Input-module__gap-20___qMJud {
  gap: 20px !important;
}

.Input-module__gap-24___hlSQ7 {
  gap: 24px !important;
}

.Input-module__gap-26___ehZmY {
  gap: 26px !important;
}

.Input-module__gap-30___IF7YC {
  gap: 30px !important;
}

.Input-module__gap-32___MujOR {
  gap: 32px !important;
}

.Input-module__gap-40___PCRAR {
  gap: 40px !important;
}

.Input-module__gap-50___PLeKa {
  gap: 50px !important;
}

.Input-module__flex-1___lKwba {
  flex: 1;
}

.Input-module__flex-none___L65Q2 {
  flex: none !important;
}

.Input-module__flex-column___q9FCb {
  display: flex;
  flex-direction: column !important;
}

.Input-module__flex-row___uOZli {
  display: flex;
  flex-direction: row !important;
}

.Input-module__vertically-centered___BZ8Pi {
  display: flex;
  align-items: center !important;
}

.Input-module__horizontally-centered___kmL8Z {
  display: flex;
  justify-content: center !important;
}

.Input-module__horizontally-end___VpwLQ {
  display: flex;
  justify-content: end !important;
}

.Input-module__vertically-start___JyeGr {
  display: flex;
  align-items: start !important;
}

.Input-module__space-between___VvhbV {
  display: flex;
  justify-content: space-between !important;
}

.Input-module__flex-wrap___K7ltr {
  flex-wrap: wrap !important;
}

.Input-module__height-100___tFZGJ {
  height: 100%;
}

.Input-module__width-50___gnDo5 {
  width: 50% !important;
}

.Input-module__width-100___lCJqX {
  width: 100%;
}

.Input-module__cursor-pointer___miwuD {
  cursor: pointer;
}

.Input-module__cursor-not-allowed___kLks5 {
  cursor: not-allowed !important;
}

.Input-module__absolute-centered___OYWnb {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Input-module__absolute___r9zbu {
  position: absolute;
}

.Input-module__relative___Dgp_D {
  position: relative;
}

.Input-module__fixed___f2wZY {
  position: fixed;
}

.Input-module__visible___deAVI {
  opacity: 1;
}

.Input-module__invisible___bUY8h {
  opacity: 0;
}

.Input-module__col-90___DLVET {
  width: 90% !important;
}

.Input-module__col-auto___lKwpI {
  width: auto !important;
}

.Input-module__medical-tabs___iDNLE {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Input-module__medical-table-new___RmCeM {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Input-module__medical-table-new___RmCeM:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Input-module__medical-table-new___RmCeM::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Input-module__medical-table-new___RmCeM::-webkit-scrollbar-track {
  display: none;
}
.Input-module__medical-table-new___RmCeM.Input-module__no-pagination___QPz89 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Input-module__medical-table-new___RmCeM.Input-module__no-pagination___QPz89:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Input-module__medical-table-new___RmCeM.Input-module__no-pagination___QPz89::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Input-module__medical-table-new___RmCeM.Input-module__no-pagination___QPz89::-webkit-scrollbar-track {
  display: none;
}

.Input-module__medical-table-empty___h5awu {
  padding: 14px 40px !important;
}

.Input-module__icon-btn___oe4Fh {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Input-module__search-icon___cK1Xs {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Input-module__disable-select___hj9YW {
  user-select: none;
}

.Input-module__break-word___HQqGQ {
  word-break: break-word;
}

.Input-module__popup-clear-btn___NWEn0 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Input-module__scroll-m-b-20___jlQIN {
  scroll-margin-bottom: 20px;
}

.Input-module__label___alenh {
  color: #637768;
}
.Input-module__label___alenh.Input-module__withError___L01fy {
  color: #db2828;
}

.Input-module__tooltipIcon___XVlxj {
  width: 14px;
  height: 14px;
}

.Input-module__optionButton___hScYi {
  margin-left: auto;
  padding: 0 !important;
  justify-content: flex-end !important;
}
.Input-module__optionButton___hScYi > span {
  font-size: 12px !important;
}

.Input-module__readOnly___u_uGc {
  display: flex;
  gap: 5px;
  color: #375844;
}

.Input-module__wrapper___R_hOT {
  border: 1px solid #637768;
  overflow: auto;
}
.Input-module__wrapper___R_hOT.Input-module__withError___L01fy {
  border: 1px solid #db2828;
}
.Input-module__wrapper___R_hOT.Input-module__withError___L01fy > span {
  color: #db2828;
  border-left-color: rgba(219, 40, 40, 0.1);
}
.Input-module__wrapper___R_hOT.Input-module__withError___L01fy > input {
  color: #db2828;
  background-color: rgba(219, 40, 40, 0.1);
}
.Input-module__wrapper___R_hOT.Input-module__withError___L01fy > input::placeholder {
  color: #db2828;
}
.Input-module__wrapper___R_hOT > span {
  color: #375844;
  margin-right: -10.5px;
  border-left: 10px solid transparent;
}
.Input-module__wrapper___R_hOT > input {
  color: #375844;
  background-color: transparent;
  font-family: var(--font-family);
  padding: 10px;
  border: none;
  width: 100%;
}
.Input-module__wrapper___R_hOT > input.Input-module__withLoader___dfoZL {
  width: calc(100% - 80px);
}
.Input-module__wrapper___R_hOT > input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: transparent;
}
.Input-module__wrapper___R_hOT > input::placeholder {
  color: #859989;
  opacity: 0.5;
}

.Input-module__error____ugR8 {
  color: #db2828;
  min-height: 15px;
}

.Input-module__warning___Fw4wI {
  color: #ffa727;
  min-height: 15px;
}

.Input-module__description___WsLeG {
  color: #375844;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/Input/Input.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ;;AA1pBA;EACE,WAAA;EACA,YAAA;AA6pBF;;AA1pBA;EACE,iBAAA;EACA,qBAAA;EACA,oCAAA;AA6pBF;AA3pBE;EACE,0BAAA;AA6pBJ;;AAzpBA;EACE,aAAA;EACA,QAAA;EACA,cAAA;AA4pBF;;AAzpBA;EACE,yBAAA;EACA,cAAA;AA4pBF;AA1pBE;EACE,yBAAA;AA4pBJ;AA1pBI;EACE,cAAA;EACA,yCAAA;AA4pBN;AAzpBI;EACE,cAAA;EACA,wCAAA;AA2pBN;AAzpBM;EACE,cAAA;AA2pBR;AAtpBE;EACE,cAAA;EACA,qBAAA;EACA,mCAAA;AAwpBJ;AArpBE;EACE,cAAA;EACA,6BAAA;EACA,+BExDK;EFyDL,aAAA;EACA,YAAA;EACA,WAAA;AAupBJ;AArpBI;EACE,wBAAA;AAupBN;AAppBI;EACE,YAAA;EACA,mBAAA;EACA,6BAAA;AAspBN;AAnpBI;EACE,cAAA;EACA,YAAA;AAqpBN;;AAhpBA;EACE,cAAA;EACA,gBAAA;AAmpBF;;AAhpBA;EACE,cAAA;EACA,gBAAA;AAmpBF;;AAhpBA;EACE,cAAA;AAmpBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.label {\n  color: get-color(greenNew, medium-dark);\n\n  &.withError {\n    color: get-color(redNew, medium);\n  }\n}\n\n.tooltipIcon {\n  width: 14px;\n  height: 14px;\n}\n\n.optionButton {\n  margin-left: auto;\n  padding: 0 !important;\n  justify-content: flex-end !important;\n\n  & > span {\n    font-size: 12px !important;\n  }\n}\n\n.readOnly {\n  display: flex;\n  gap: 5px;\n  color: get-color(greenNew, dark);\n}\n\n.wrapper {\n  border: 1px solid get-color(greenNew, medium-dark);\n  overflow: auto;\n\n  &.withError {\n    border: 1px solid get-color(redNew, medium);\n\n    & > span {\n      color: get-color(redNew, medium);\n      border-left-color: get-color(redNew, light);\n    }\n\n    & > input {\n      color: get-color(redNew, medium);\n      background-color: get-color(redNew, light);\n\n      &::placeholder {\n        color: get-color(redNew, medium);\n      }\n    }\n  }\n\n  & > span {\n    color: get-color(greenNew, dark);\n    margin-right: -10.5px;\n    border-left: 10px solid transparent;\n  }\n\n  & > input {\n    color: get-color(greenNew, dark);\n    background-color: transparent;\n    font-family: $roboto;\n    padding: 10px;\n    border: none;\n    width: 100%;\n\n    &.withLoader {\n      width: calc(100% - 80px);\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n      background-color: transparent;\n    }\n\n    &::placeholder {\n      color: get-color(greenNew, medium);\n      opacity: 0.5;\n    }\n  }\n}\n\n.error {\n  color: get-color(redNew, medium);\n  min-height: 15px;\n}\n\n.warning {\n  color: get-color(orange, medium);\n  min-height: 15px;\n}\n\n.description {\n  color: get-color(greenNew, dark);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Input-module__font-s-10___b_NC6`,
	"fontS12": `Input-module__font-s-12___DSbbW`,
	"fontS13": `Input-module__font-s-13___hSlV_`,
	"fontS14": `Input-module__font-s-14___X7AKK`,
	"fontS15": `Input-module__font-s-15___vvPgb`,
	"fontS16": `Input-module__font-s-16___KMzXs`,
	"fontS18": `Input-module__font-s-18___IRkTp`,
	"fontS20": `Input-module__font-s-20___mNSGc`,
	"fontS22": `Input-module__font-s-22___Pyub4`,
	"fontS28": `Input-module__font-s-28___x294D`,
	"fontW400": `Input-module__font-w-400___MYviU`,
	"fontW500": `Input-module__font-w-500___mJ6OI`,
	"fontW600": `Input-module__font-w-600___FRQ9C`,
	"fontW700": `Input-module__font-w-700____cycW`,
	"p5": `Input-module__p-5___B9gxb`,
	"p12": `Input-module__p-12___dnzEN`,
	"p16": `Input-module__p-16___PUREQ`,
	"p30": `Input-module__p-30___FleIU`,
	"pB0": `Input-module__p-b-0___ALb_p`,
	"pB5": `Input-module__p-b-5___Cfw5j`,
	"pB10": `Input-module__p-b-10___GqgnO`,
	"pB12": `Input-module__p-b-12___rvgXF`,
	"pB16": `Input-module__p-b-16___UZdYT`,
	"pB18": `Input-module__p-b-18___SEXaA`,
	"pB20": `Input-module__p-b-20___AwO0h`,
	"pB25": `Input-module__p-b-25___eCC4z`,
	"pB30": `Input-module__p-b-30___PwszH`,
	"pB50": `Input-module__p-b-50___yY8HM`,
	"pT0": `Input-module__p-t-0___oHq55`,
	"pT12": `Input-module__p-t-12___F_pTg`,
	"pT16": `Input-module__p-t-16___LFBQC`,
	"pT18": `Input-module__p-t-18___f8Wmj`,
	"pT20": `Input-module__p-t-20___Zj1Sc`,
	"pT30": `Input-module__p-t-30___Cohzr`,
	"pT40": `Input-module__p-t-40___wvKXa`,
	"pT50": `Input-module__p-t-50___hW_fP`,
	"pL20": `Input-module__p-l-20___s5xqr`,
	"pL30": `Input-module__p-l-30____FWsC`,
	"pL40": `Input-module__p-l-40___fjVuK`,
	"pR16": `Input-module__p-r-16___cJsy4`,
	"pR20": `Input-module__p-r-20___wtVWr`,
	"pR30": `Input-module__p-r-30___sQ1Tt`,
	"pR50": `Input-module__p-r-50___YRp5u`,
	"pR60": `Input-module__p-r-60___a4Zgw`,
	"mB1": `Input-module__m-b-1___fY0im`,
	"mB2": `Input-module__m-b-2___fdkQ5`,
	"mB6": `Input-module__m-b-6___Rrbdb`,
	"mB8": `Input-module__m-b-8___MJuGL`,
	"mB10": `Input-module__m-b-10___P3SMb`,
	"mB14": `Input-module__m-b-14___g9bqX`,
	"mB16": `Input-module__m-b-16___eUu1l`,
	"mB20": `Input-module__m-b-20___xfCrz`,
	"mB22": `Input-module__m-b-22___Zrjeb`,
	"mB24": `Input-module__m-b-24___NxEFx`,
	"mB30": `Input-module__m-b-30___dxJZr`,
	"mB32": `Input-module__m-b-32___MiVno`,
	"mB40": `Input-module__m-b-40___m6asB`,
	"mT2": `Input-module__m-t-2___MaRrL`,
	"mT3": `Input-module__m-t-3___mVTFn`,
	"mT4": `Input-module__m-t-4___dxSjt`,
	"mT5": `Input-module__m-t-5___CHyZG`,
	"mT8": `Input-module__m-t-8___rSoyu`,
	"mT10": `Input-module__m-t-10___sb9lr`,
	"mT15": `Input-module__m-t-15___SIbRr`,
	"mT16": `Input-module__m-t-16___wux7P`,
	"mT20": `Input-module__m-t-20___QZqs5`,
	"mT22": `Input-module__m-t-22___nQE4j`,
	"mT30": `Input-module__m-t-30___owRzp`,
	"mT32": `Input-module__m-t-32____vHym`,
	"mLAuto": `Input-module__m-l-auto___KCGxW`,
	"mL4": `Input-module__m-l-4___WUuti`,
	"mL5": `Input-module__m-l-5___b2oNG`,
	"mL6": `Input-module__m-l-6___u9CRM`,
	"mL8": `Input-module__m-l-8___WUQr2`,
	"mL10": `Input-module__m-l-10___h8dfZ`,
	"mL16": `Input-module__m-l-16___qUWKC`,
	"mL20": `Input-module__m-l-20___Uo7B2`,
	"mL24": `Input-module__m-l-24___YaFIM`,
	"mL30": `Input-module__m-l-30___uF5OW`,
	"mL35": `Input-module__m-l-35___al3mX`,
	"mL40": `Input-module__m-l-40___rw_Vj`,
	"mR8": `Input-module__m-r-8___O1Nfk`,
	"mR10": `Input-module__m-r-10___nBc14`,
	"mR16": `Input-module__m-r-16___zZFax`,
	"mR20": `Input-module__m-r-20___to2kX`,
	"mR24": `Input-module__m-r-24___jxLaL`,
	"mR30": `Input-module__m-r-30___qywy6`,
	"mR40": `Input-module__m-r-40___mwUyh`,
	"borderR3": `Input-module__border-r-3___nF9dM`,
	"borderR4": `Input-module__border-r-4____5nPG`,
	"borderR6": `Input-module__border-r-6___obl0P`,
	"borderR10": `Input-module__border-r-10___iWydD`,
	"borderR12": `Input-module__border-r-12___Vv7qq`,
	"borderR16": `Input-module__border-r-16___ZMYOF`,
	"borderR50": `Input-module__border-r-50___Zh9N8`,
	"primaryBorder": `Input-module__primary-border___uuJSo`,
	"primaryBorderB": `Input-module__primary-border-b___bCU8s`,
	"primaryBorderT": `Input-module__primary-border-t___EpYOn`,
	"primaryBorderL": `Input-module__primary-border-l___ekDX6`,
	"primaryBorderR": `Input-module__primary-border-r___fEdNp`,
	"secondaryBorder": `Input-module__secondary-border___q72kD`,
	"secondaryBorderB": `Input-module__secondary-border-b___RIrjp`,
	"secondaryBorderT": `Input-module__secondary-border-t___fYbTA`,
	"secondaryBorderL": `Input-module__secondary-border-l___g3P7s`,
	"secondaryBorderR": `Input-module__secondary-border-r___LJUcR`,
	"gap0": `Input-module__gap-0___WcfK1`,
	"gap2": `Input-module__gap-2___kAEKl`,
	"gap4": `Input-module__gap-4___EF5U5`,
	"gap5": `Input-module__gap-5___ljDha`,
	"gap6": `Input-module__gap-6___NyRsM`,
	"gap8": `Input-module__gap-8___VaOBt`,
	"gap10": `Input-module__gap-10___t9mZE`,
	"gap12": `Input-module__gap-12___rTE5S`,
	"gap14": `Input-module__gap-14___afKUs`,
	"gap16": `Input-module__gap-16___QzhAt`,
	"gap18": `Input-module__gap-18___mtad9`,
	"gap20": `Input-module__gap-20___qMJud`,
	"gap24": `Input-module__gap-24___hlSQ7`,
	"gap26": `Input-module__gap-26___ehZmY`,
	"gap30": `Input-module__gap-30___IF7YC`,
	"gap32": `Input-module__gap-32___MujOR`,
	"gap40": `Input-module__gap-40___PCRAR`,
	"gap50": `Input-module__gap-50___PLeKa`,
	"flex1": `Input-module__flex-1___lKwba`,
	"flexNone": `Input-module__flex-none___L65Q2`,
	"flexColumn": `Input-module__flex-column___q9FCb`,
	"flexRow": `Input-module__flex-row___uOZli`,
	"verticallyCentered": `Input-module__vertically-centered___BZ8Pi`,
	"horizontallyCentered": `Input-module__horizontally-centered___kmL8Z`,
	"horizontallyEnd": `Input-module__horizontally-end___VpwLQ`,
	"verticallyStart": `Input-module__vertically-start___JyeGr`,
	"spaceBetween": `Input-module__space-between___VvhbV`,
	"flexWrap": `Input-module__flex-wrap___K7ltr`,
	"height100": `Input-module__height-100___tFZGJ`,
	"width50": `Input-module__width-50___gnDo5`,
	"width100": `Input-module__width-100___lCJqX`,
	"cursorPointer": `Input-module__cursor-pointer___miwuD`,
	"cursorNotAllowed": `Input-module__cursor-not-allowed___kLks5`,
	"absoluteCentered": `Input-module__absolute-centered___OYWnb`,
	"absolute": `Input-module__absolute___r9zbu`,
	"relative": `Input-module__relative___Dgp_D`,
	"fixed": `Input-module__fixed___f2wZY`,
	"visible": `Input-module__visible___deAVI`,
	"invisible": `Input-module__invisible___bUY8h`,
	"col90": `Input-module__col-90___DLVET`,
	"colAuto": `Input-module__col-auto___lKwpI`,
	"medicalTabs": `Input-module__medical-tabs___iDNLE`,
	"medicalTableNew": `Input-module__medical-table-new___RmCeM`,
	"noPagination": `Input-module__no-pagination___QPz89`,
	"medicalTableEmpty": `Input-module__medical-table-empty___h5awu`,
	"iconBtn": `Input-module__icon-btn___oe4Fh`,
	"searchIcon": `Input-module__search-icon___cK1Xs`,
	"disableSelect": `Input-module__disable-select___hj9YW`,
	"breakWord": `Input-module__break-word___HQqGQ`,
	"popupClearBtn": `Input-module__popup-clear-btn___NWEn0`,
	"scrollMB20": `Input-module__scroll-m-b-20___jlQIN`,
	"label": `Input-module__label___alenh`,
	"withError": `Input-module__withError___L01fy`,
	"tooltipIcon": `Input-module__tooltipIcon___XVlxj`,
	"optionButton": `Input-module__optionButton___hScYi`,
	"readOnly": `Input-module__readOnly___u_uGc`,
	"wrapper": `Input-module__wrapper___R_hOT`,
	"withLoader": `Input-module__withLoader___dfoZL`,
	"error": `Input-module__error____ugR8`,
	"warning": `Input-module__warning___Fw4wI`,
	"description": `Input-module__description___WsLeG`
};
module.exports = ___CSS_LOADER_EXPORT___;
